<div class="centering-string">
  <svg-icon key="info"></svg-icon>
  <span translate data-qa="notice">kkm.action.vpn.sign</span>
</div>

<div class="card" *ngIf="retailPlaceData">
  <div class="ui-kit-rows-layout" data-qa-block="organization-info">
    <span class="ui-kit-block-title" translate data-qa="block-title">kkm.organisation.title</span>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="name-title">retail.place.title</span>
      <span data-qa="name">{{ retailPlaceData.title }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="iin-title">organization.iin</span>
      <span data-qa="iin">{{ retailPlaceData.IIN || retailPlaceData.BIN }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="responsible-person-title"
        >retailPlace.vpn.responsible.person</span
      >
      <span data-qa="responsible-person">{{ retailPlaceData.responsiblePerson }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="legal-address-title">organization.legal.address</span>
      <span data-qa="legal-address">{{ retailPlaceData.legalAddress.fullAddress }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="actual-address-title"
        >organization.actual.address</span
      >
      <span data-qa="actual-address">{{ retailPlaceData.actualAddress.fullAddress }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="bank-name-title">retailPlace.vpn.bank.title</span>
      <span data-qa="bank-name">{{ retailPlaceData.bank }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="bic-title">organization.bic</span>
      <span data-qa="bic">{{ retailPlaceData.bic }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="iik-title">organization.iik</span>
      <span data-qa="iik">{{ retailPlaceData.paymentAccount }}</span>
    </div>
  </div>

  <hr class="greyline" />

  <div class="ui-kit-rows-layout" data-qa-block="retail-place-info">
    <span class="ui-kit-block-title" translate data-qa="block-title">retailPlace.vpn.kkm.data</span>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="retail-place-name-title">retail.place.title</span>
      <span data-qa="retail-place-name">{{ retailPlaceData.retailPlaceTitle }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="retail-place-address-title"
        >kkm.settings.retail.place.address</span
      >
      <span data-qa="retail-place-address">{{
        retailPlaceData.retailPlaceAddress.fullAddress
      }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="phone-title">organization.phone</span>
      <span data-qa="phone">{{ retailPlaceData.phone }}</span>
    </div>
    <div class="ui-kit-layout-columns-2">
      <span class="colon" translate data-qa="kkm-amount-title">retailPlace.vpn.kkm.amount</span>
      <span data-qa="kkm-amount">{{ retailPlaceData.kkmAmount }}</span>
    </div>
  </div>
</div>

<div class="ui-kit-bottom-buttons-block">
  <button class="button_link" (click)="back()" data-qa-button="go-back" translate>
    button.cancel
  </button>

  <button
    *ngIf="data"
    class="button_blue"
    data-qa-button="sign"
    [taxOpenCertificateModal]="{ data }"
    (signatureGenerated)="setSignature($event)"
    translate
  >
    button.sign
  </button>
</div>
